import React, { useRef, useState } from 'react';
import { Button, Divider, Input, Select, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { collect } from 'collect.js';
import { ProductAdditives } from '../../../services/exports/Constants';
import str from '../../../services/helpers/Stringable';

export default function AdditivesSelect({ value, onChange, extraOptions, allowAdd, ...rest }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Form:Menu:AdditivesSelect' });
  const { t: tAdditives } = useTranslation(undefined, { keyPrefix: 'Shared:Additives' });
  const getAdditiveTranslation = ({ value }) =>
    tAdditives(`options.${value}`, { defaultValue: str(value).toHuman().upper().toString() });

  const [options, setOptions] = useState(
    collect([...Object.values(ProductAdditives), ...(extraOptions ?? [])])
      .unique()
      .toArray(),
  );
  const [name, setName] = useState('');
  const inputRef = useRef(null);

  const onNameChange = (event) => {
    setName(event.target.value);
  };

  const addItem = (e) => {
    e.preventDefault();

    if (!name) {
      return;
    }

    setOptions((current) => [...current, name]);
    setName('');
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  return (
    <Select
      value={value}
      onChange={onChange}
      popupRender={(menu) => (
        <>
          {menu}
          {allowAdd && (
            <>
              <Divider style={{ margin: '8px 0' }} />
              <Space style={{ padding: '0 8px 4px' }}>
                <Input
                  placeholder={t('custom_additive.placeholder')}
                  ref={inputRef}
                  value={name}
                  onChange={onNameChange}
                  onKeyDown={(e) => e.stopPropagation()}
                />
                <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
                  {t('buttons.add')}
                </Button>
              </Space>
            </>
          )}
        </>
      )}
      options={options.map((item) => ({ label: item, value: item }))}
      labelRender={getAdditiveTranslation}
      optionRender={getAdditiveTranslation}
      {...rest}
    />
  );
}
